module.exports = __webpack_public_path__ + "static/img/more-kefu.72148675.png";